import "bootstrap";
import "whatwg-fetch";
import "summernote/dist/summernote-bs5.js";
import "summernote/dist/summernote-bs5.css";

import { DialogConfiguration } from "aurelia-dialog";
import { Aurelia, PLATFORM } from "aurelia-framework";
import { UserManager } from "oidc-client";
import { BootstrapFormRenderer } from "./common/bootstrap-form-renderer";

import Infrastructure from "./common/infrastructure";
import { OidcConfiguration } from "./common/oidc-configuration";

import { helperTestingAgency } from "./common/vue-helpers/testing-agency-check";

/// <reference types="aurelia-loader-webpack/src/webpack-hot-interface"/>
// we want font-awesome to load as soon as possible to show the fa-spinner
export async function configure(aurelia: Aurelia) {
    aurelia.use
        .standardConfiguration()
        .developmentLogging()
        .feature(PLATFORM.moduleName("resources/index"))
        .plugin(PLATFORM.moduleName("aurelia-validation"))
        .plugin(PLATFORM.moduleName("bcx-aurelia-reorderable-repeat"))
        .plugin(PLATFORM.moduleName("aurelia-dialog"), (config: DialogConfiguration) => {
            config.useDefaults();
            config.settings.lock = true;
            config.settings.centerHorizontalOnly = false;
            config.settings.startingZIndex = 9999;
        });

    let oidcConfig: OidcConfiguration = aurelia.container.get(OidcConfiguration);
    let userManager = oidcConfig.createUserManager();
    aurelia.container.registerInstance(UserManager, userManager);
    // Silent-renew iframe must only hand the token back to the parent, never boot the app.
    if (window.location.pathname === "/oidc/sign-in-silent") {
        await userManager.signinSilentCallback();
        return;
    }
    aurelia.container.registerHandler("bootstrap-form-renderer", (x) => x.get(BootstrapFormRenderer));
    saveAxxessCentralRedirect(window.location.pathname);
    saveSignoutSyncPath(window.location.search);
    const shouldShowVue = await helperTestingAgency.shouldMountVue();
    if (shouldShowVue) {
        const isMounted = await helperTestingAgency.mountVueApp();
        if (isMounted) {
            logVersion();
            return;
        }
    }
    await aurelia.start();
    await aurelia.setRoot(PLATFORM.moduleName("pages/app/app"));
    logVersion();
}

function logVersion(): void {
    console.log(`Running release version '${Infrastructure.releaseVersion}'.`);
    console.log(`Running release environment '${Infrastructure.releaseEnvironment}'.`);
    console.log(`Running build version '${Infrastructure.buildVersion}'.`);
}

function saveAxxessCentralRedirect(path: string): void {
    if (path.startsWith("/axxess-central/Redirect")) {
        localStorage.setItem("axxesscentral-solution-redirect", window.location.search);
    }
}

function saveSignoutSyncPath(searchParams: string): void {
    const params = new URLSearchParams(searchParams);
    if (params.get("logoutCallbackSync")) {
        localStorage.setItem("logoutCallbackSync", params.get("logoutCallbackSync"));
    }
}
